import React from 'react';
import { Link } from 'react-router-dom';
import './BlogCard.css';

const BlogCard = ({ post }) => {
  return (
    <div className="blog-card">
      <div className="blog-card-image">
        <img src={post.image} alt={post.title} loading="lazy" />
        <span className="category-badge">{post.category}</span>
      </div>
      <div className="blog-card-content">
        <div className="blog-meta">
          <span>{post.date}</span>
          <span>•</span>
          <span>{post.readTime} read</span>
        </div>
        <h3>
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h3>
        <p>{post.excerpt}</p>
        <Link to={`/blog/${post.slug}`} className="read-more">
          Read More →
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;